import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useMemo } from "react";
import { getTickValues } from "./utils";
import { ReportChartProps } from "@repo/core/components/chart/ReportCharts/types";
import { BarChartProps } from "./BarChart/types";

export const ReportChartsController = ({
  data,
  isStackedBars,
  maxValue,
  numberOfGridLines,
  customStyles
}: Pick<ReportChartProps, "data" | "maxValue" | "numberOfGridLines"> &
  Pick<BarChartProps, "isStackedBars" | "customStyles">) => {
  const { isMobile } = useDimensions();

  const tickValues = getTickValues(maxValue, numberOfGridLines);
  const { styles, indicatorsData } = useMemo(() => {
    const styles = {
      chartPadding: {
        top: 24,
        bottom: 46,
        right: 58,
        left: 58
      },
      bottomAxisStyle: {
        axis: { stroke: "#a1a1a1" },
        tickLabels: {
          fill: "#525252",
          fontSize: isMobile ? 10 : 12,
          fontWeight: 500,
          padding: isMobile ? 6 : 6
        }
      },
      leftAxisStyle: {
        grid: { stroke: "transparent", strokeWidth: 1 },
        axis: { stroke: "#a1a1a1" },
        ticks: { stroke: "transparent" },
        tickLabels: { fill: "#525252", fontSize: isMobile ? 10 : 12 }
      },
      rightAxisStyle: {
        axis: { stroke: "#a1a1a1" },
        ticks: { stroke: "transparent" },
        tickLabels: { fill: "#525252", fontSize: isMobile ? 10 : 12 }
      },
      groupStyle: {
        data: customStyles?.barStyle ?? {
          width: isStackedBars ? 42 : 16
        }
      }
    };

    // Array from to avoid mutation. We need this to show the correct order of indicator in the stacked bars.
    const indicatorsData = isStackedBars ? Array.from(data).reverse() : data;

    return {
      styles,
      indicatorsData
    };
  }, [isMobile, isStackedBars, data, customStyles]);

  return { isMobile, tickValues, styles, indicatorsData };
};
